import React from 'react';
import clsx from 'clsx';
import { createStyles, Theme, withStyles, WithStyles } from '@material-ui/core/styles';
import Divider from '@material-ui/core/Divider';
import Drawer, { DrawerProps } from '@material-ui/core/Drawer';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import { Omit } from '@material-ui/types';
import { NavigatorData, NavigatorEntry, NavigatorSection } from './NavigatorData';
import { Collapse } from '@material-ui/core';
import { AuthContext } from '../authentication/AuthContext';
import NavItem from './NavItem';
import { useLocation } from 'react-router-dom';
import { MuiStyles } from './styling/MuiStyles';
import { DeltaXMLColors, MyDeltaColors } from './styling/DeltaColors';
import { Button } from "@material-ui/core";
import RequestEvaluation, { MenuItemFormatType, EvalData, EvalStatus } from "./RequestEvaluation";
import { ProfileDetails } from './ProfileContent';
import { LicenseRequestData } from './Paperbase';


const styles = (theme: Theme) =>
  createStyles({
    categoryHeader: {
      paddingTop: theme.spacing(2),
      paddingBottom: theme.spacing(2),
    },
    itemCategory: {
      backgroundColor: DeltaXMLColors.DARK_BACKGROUND,
      paddingTop: theme.spacing(2),
      paddingBottom: theme.spacing(2),
      justifyContent: 'center',
    },
    firebase: {
      fontSize: MuiStyles.MuiTheme.typography.h3.fontSize,
      fontWeight: MuiStyles.MuiTheme.typography.h3.fontWeight,
      lineHeight: MuiStyles.MuiTheme.typography.h3.lineHeight,
      fontFamily: MuiStyles.MuiTheme.typography.h3.fontFamily,
      color: MyDeltaColors.WHITE,
      height: '65px'
    },
    divider: {
      marginTop: theme.spacing(2),
      backgroundColor: DeltaXMLColors.OXFORD_BLUE,
    },
    margin: {
      margin: theme.spacing(2),
    },
    topDivider: {
      backgroundColor: DeltaXMLColors.OXFORD_BLUE,
    },
    appLogo: {
      height: MuiStyles.appLogoDimensions.height,
      width: MuiStyles.appLogoDimensions.width
    }
  });

export interface NavigatorProps extends Omit<DrawerProps, 'classes'>, WithStyles<typeof styles> {
  downloadSections: NavigatorEntry[],
  downloadLegacySections: NavigatorEntry[],
  downloadServerSections: NavigatorEntry[],
  profileDetails: ProfileDetails,
  evalAllowedProducts: MenuItemFormatType[] | undefined,
  evalRequestStatus: EvalStatus,
  licenseRequestState: LicenseRequestData,
  handleRequestEvaluation: (evalData: EvalData) => void
}

function Navigator(props: NavigatorProps) {
  const auth = React.useContext(AuthContext);
  const { classes, downloadServerSections, downloadSections, downloadLegacySections, profileDetails, handleRequestEvaluation, evalRequestStatus, evalAllowedProducts, licenseRequestState, ...other } = props;
  const navigationSections: NavigatorSection[] = NavigatorData.RootSectionsAuthenticated;
  const [saasProdOpen, setSaasProdOpen] = React.useState(false);
  const [downloadOpen, setDownloadOpen] = React.useState(false);
  const [openRequestEval, setOpenRequestEval] = React.useState(false);
  const legacy: boolean = downloadLegacySections && downloadLegacySections.length > 0;
  const legacyNavSection: NavigatorEntry = NavigatorData.DownloadSections.find((data) => data.id === "Legacy Downloads")!;

  const onSaasProdhandleClick = () => {
    setSaasProdOpen(!saasProdOpen);
  };
  const onDownloadhandleClick = () => {
    setDownloadOpen(!downloadOpen);
  };

  let location = useLocation();
  React.useEffect(() => {
    const locationParts = location.pathname.split('/');
    if (locationParts.length > 2 && '/' + locationParts[1] === NavigatorData.saasProductsBaseUrl) {
      setSaasProdOpen(true);
    }
  }, [location]);

  const handleRequestEvalDialogOpen= (open: boolean) => {
    setOpenRequestEval(open);
  }

  return (
    <Drawer variant="permanent" {...other}>
      <List disablePadding>

        <ListItem className={clsx(classes.firebase, classes.itemCategory)}>
          <img src="/DeltaXignia_LogoMark_Colour.svg" alt="DeltaXML" className={classes.appLogo} />
          MyDelta
        </ListItem>
        <Divider className={classes.topDivider} />
        {navigationSections.map(({ id, children }) => (
          <React.Fragment key={id}>
            {/* empty category header to maintain separation between heading and navigation list items */}
            <ListItem className={classes.categoryHeader} />
            {children.map(({ id: childId, link: linkRef, icon }) => {
              if (childId === 'Downloads') {
                return (
                  <div key={id + '-' + childId}>
                    <NavItem id={childId} link={linkRef} icon={icon} hasListItems={downloadSections.length > 0} isOpen={downloadOpen} handleClick={onDownloadhandleClick} />
                    <Collapse in={downloadOpen} timeout="auto" unmountOnExit>
                      <List disablePadding>
                        {downloadSections && downloadSections.map(({ id: productId, link: productLinkRef, icon: productIcon }) => (
                          <NavItem key={productId} id={productId} link={productLinkRef} icon={productIcon} isNested={true} />
                        ))}
                        <Divider variant='middle'/>
                        {downloadServerSections && downloadServerSections.map(({ id: productId, link: productLinkRef, icon: productIcon }) => (
                          <NavItem key={productId} id={productId} link={productLinkRef} icon={productIcon} isNested={true} />
                        ))}
                        {legacy && (
                          <>
                            <Divider variant='middle'/>
                            <NavItem key={legacyNavSection.id} id={legacyNavSection.id} link={legacyNavSection.link} icon={legacyNavSection.icon} isNested={true} />
                          </>
                        )}
                      </List>
                    </Collapse>
                  </div>
                )
              }
              else {
                return (
                  <NavItem key={id + '-' + childId} id={childId} link={linkRef} icon={icon} />
                )
              }
            })}
            <Divider className={classes.divider} />
          </React.Fragment>
        ))}
      </List>
      {/* {auth.isAuthenticated()&& 
        <>
          <RequestEvaluation  open={openRequestEval} handleRequestEvalDialogOpen={handleRequestEvalDialogOpen} profileDetails={profileDetails} handleRequestEvaluation={handleRequestEvaluation} evalAllowedProducts={evalAllowedProducts} evalRequestStatus={evalRequestStatus} licenseRequestState={licenseRequestState}/>
          <Button className={classes.margin} variant="contained" color="secondary"  id="SignOutButton" onClick={()=>handleRequestEvalDialogOpen(!openRequestEval)}>Request Evaluation</Button>
        </>
      } */}
    </Drawer>
  );
}

export default withStyles(styles)(Navigator);